import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, distinctUntilChanged, startWith, takeUntil } from 'rxjs';
import { PayeeCasesService } from 'src/app/shared/payee-cases/payee-cases.service';
import { PayeeFormFieldComponent } from '../../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';

@Component({
  selector: 'app-law-firm-filter',
  templateUrl: './law-firm-filter.component.html',
  styleUrls: ['./law-firm-filter.component.scss'],
  imports: [PayeeFormFieldComponent, FormsModule, ReactiveFormsModule],
})
export class LawFirmFilterComponent implements OnInit, OnDestroy {
  private payeeCasesService = inject(PayeeCasesService);

  private readonly destroy = new Subject<void>();
  readonly law_firm_name = new FormControl<string | null>(null);

  ngOnInit(): void {
    this.payeeCasesService.law_firm_name
      .pipe(
        startWith(this.payeeCasesService.law_firm_name.value),
        takeUntil(this.destroy),
        distinctUntilChanged(),
      )
      .subscribe((v) => this.law_firm_name.patchValue(v, { emitEvent: false }));

    this.law_firm_name.valueChanges
      .pipe(takeUntil(this.destroy), distinctUntilChanged())
      .subscribe((v) => this.payeeCasesService.law_firm_name.next(v));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
